import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Button, Input, AutoComplete, Collapse, Divider } from 'antd';
import { LoadingSpinner } from './LoadingSpinner';
import DomainItem from '../components/DomainItem';
import { EmptyState } from './EmptyState';
import SVG from 'react-inlinesvg';
import {
  UpOutlined,
  CloseOutlined,
  PlusOutlined,
  EnterOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { analytics } from '../modules/analytics';


const { Panel } = Collapse;

export class DomainMap extends React.Component {
  state = {
    addDomainSuggestions: [],
    showDomainForm: false,
  }

  static propTypes = {
    domain: PropTypes.shape({
      domains: PropTypes.array.isRequired,
      status: PropTypes.string,
    }).isRequired,

    getDomains: PropTypes.func.isRequired,
    addDomain: PropTypes.func.isRequired,
    deleteDomain: PropTypes.func.isRequired,
    checkDomainReachability: PropTypes.func.isRequired,
    refreshDomain: PropTypes.func.isRequired,

    networkError: PropTypes.bool,
  };

  componentDidMount() {
    console.log('adfasd');
    analytics.trackView('/domains');
    if (this.props.domain.status === 'init') {
      this.props.getDomains();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.networkError && !this.props.networkError) {
      this.props.getDomains();
    }
  }

  onAddDomainSelect = (value) => {
    this.props.addDomain(value);
    this.setState({addDomainSuggestions: []});
  };

  commonTlds = [
    'com',
    'net',
    'org',
    'info',
    'io',
  ];

  deleteDomain = (domainUrlsafe) => {
    this.props.deleteDomain(domainUrlsafe);
  };

  refreshDomain = (domainUrlsafe) => {
    this.props.refreshDomain(domainUrlsafe);
  };

  checkDomainReachability = (domainUrlsafe) => {
    this.props.checkDomainReachability(domainUrlsafe);
  };

  onAddDomainSearch = (value) => {
    if (!value) {
      this.setState({ addDomainSuggestions: [] });
      return;
    }
    const entry = value.replace(/\s/g, '');
    if (entry.length === 0) {
      this.setState({ addDomainSuggestions: [] });
      return;
    }

    // this.setState({ domain: entry });

    const segments = entry.split('.');
    if (segments.length === 1) {
      const suggestions = this.commonTlds.map(t => (
        { value: `${entry}.${t}` }
      ));
      this.setState({
        addDomainSuggestions: suggestions,
      });
      return;
    }

    const lastSegment = segments.pop();
    const sanslastSegment = segments.join('.');

    const suggestions = this.commonTlds
      .filter(t => (t.startsWith(lastSegment)))
      .map(t => (`${sanslastSegment}.${t}`));

    if (!suggestions.includes(entry) && !entry.endsWith('.')) {
      suggestions.push(entry);
    }

    this.setState({
      addDomainSuggestions: suggestions.map(s => ({value: s})),
    });
  };

  toggleDomainAddForm = () => {
    this.setState({ showDomainForm: !this.state.showDomainForm });
  };

  render() {
    const { domains, status } = this.props.domain;
    const isLoading = status === 'loading';
    const isEmpty = (domains.length === 0);

    if (isLoading) {
      return <LoadingSpinner />;
    }

    const addDomainButtonWrapper = (
      <React.Fragment>
        <div className="w-100">
          <AutoComplete
            className="domain-add w-100"
            options={this.state.addDomainSuggestions}
            onSelect={this.onAddDomainSelect}
            onSearch={this.onAddDomainSearch}
            onBlur={()=>{this.setState({addDomainSuggestions:[]});}}
            placeholder="www.game-changer.com"
          >
            <Input />
          </AutoComplete>
        </div>
        <div className="text-secondary text-left small mt-1">
          Enter the URL exactly as you would like it to appear to your users, including the subdomain.
          For example, try.megacorp.com is different from megacorp.com.
        </div>
      </React.Fragment>
    );

    const emptyState = (
      <EmptyState
        title='Bring your own domain'
        subtitle="Enter a domain you already own, and we'll guide you through the rest."
        graphics={<SVG src={require('assets/media/domain/domain-empty.svg')} />}
      >
        <div className="row no-gutters align-self-stretch">
          <div className="col-12 col-lg-10 mx-auto">
            {addDomainButtonWrapper}
          </div>
        </div>
      </EmptyState>
    );

    const domainItems = domains.map((domain) => (
      <DomainItem
        key={domain.urlsafe}
        {...domain}
        deleteDomain={this.deleteDomain}
        checkDomainReachability={this.checkDomainReachability}
        refreshDomain={this.refreshDomain}
      />
    ));

    const header = (
      <div className="row mb-3">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <div className="text-secondary d-inline-block">
            Showing { domains.length } domain{ domains.length > 1 ? 's' : ''}
          </div>
          <div>
            { this.state.showDomainForm ? (
              <Button
                type="link" onClick={this.toggleDomainAddForm}
                icon={<CloseOutlined />}
              >
                Close
              </Button>) : (
              <Button
                type="primary" onClick={this.toggleDomainAddForm}
                icon={<PlusOutlined />}
              >
                Add another domain
              </Button>
            )}
          </div>
        </div>
      </div>
    );

    // <Divider className="mt-5" />
    // <h5 className="my-3">Common questions</h5>
    //
    // <Collapse accordion className="text-left">
    //   <Panel header="What is the purpose of a domain?" key="what-is-a-domain">
    //     <p>
    //       In simple terms, your domain is your landing page's URL.
    //       It's the link people click on or type in the address bar
    //       to visit your landing page.
    //     </p>
    //     <p>
    //       To get this working, you need to first register
    //       a domain name, say&nbsp;<b>my-company.com</b>.
    //       You then add subdomains (www for example)
    //       and an optional path (/my-product) to create the final URL.
    //     </p>
    //   </Panel>
    //
    //   <Panel header="Where can I buy my domain?" key="where-to-buy">
    //     <p>
    //       PageHits does not sell domains. You can buy yours from
    //       well-known domain registrars such as Godaddy, Namecheap,
    //       Google Domains to name a few.
    //     </p>
    //     <p>
    //       As always, do your own research based on your specific
    //       requirements (price, support etc.) before making
    //       a purchase decision. You can always transfer your domains
    //       from one registrar to another in the future.
    //     </p>
    //   </Panel>
    //   <Panel header="Can I try PageHits if I don't own a domain yet?" key="co-exist">
    //     <p>
    //       Absolutely.
    //     </p>
    //     <p>
    //       You can use on-pagehits.com, a complimentary domain provided
    //       by PageHits, till you buy your own.
    //
    //       You can add a prefix of your choice such as&nbsp;
    //       <b>my-company.</b>on-pagehits.com for use with
    //       your landing pages.
    //     </p>
    //   </Panel>
    //   <Panel header="My domain is already in use elsewhere. Do I need a separate domain for PageHits?" key="buy-new-domain">
    //     <p>
    //       A domain can be used with more than one services
    //       simultaneously. It is infact a common practice.
    //     </p>
    //     <p>
    //       For example, you can use your domain my-company.com with
    //       your mail server (mail.my-company.com),
    //       your wordpress blog (blog.my-company.com)
    //       and your PageHits landing pages (get.my-company.com).
    //     </p>
    //   </Panel>
    // </Collapse>

    return (
      <div className="app__domain">
        <Helmet>
          <title>My Domains</title>
        </Helmet>

        <div>

          { isEmpty ? emptyState : header }

          { this.state.showDomainForm ? (
            <div className="row my-5">
              <div className="col-md-10 col-lg-9 mx-auto">
                <div className="text-secondary">
                  Own a domain? Enter it here.
                  And we'll guide you through the rest.
                </div>
                { addDomainButtonWrapper }
              </div>
            </div>
          ) : null }

          { domainItems }

        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/presentation/DomainMap.jsx